import React from 'react';

import { ProductType } from 'constants/product';

//
// --- Types ---

interface ProductSwitchProps {
  /** children should be `ProductMatch` components, or have a `product` prop */
  children: React.ReactElement[];
  /** current product type the app is set to; determines which children to display */
  currentProduct: ProductType;
}

//
// --- ProductSwitch Component ---

/**
 * Render different children based on current product. Use `ProductMatch` components
 * for children.
 */
const ProductSwitch: React.FC<ProductSwitchProps> = props => {
  const { currentProduct, children } = props;

  const matchedChild = children.find(child => {
    const productToMatch = child?.props?.product;

    return productToMatch
      ? Array.isArray(productToMatch)
        ? productToMatch.includes(currentProduct)
        : child.props.product === currentProduct
      : false;
  });

  return matchedChild || null;
};

export default ProductSwitch;
